/*eslint-disable no-undef*/
/* eslint no-underscore-dangle: 0 */

__webpack_public_path__ = window.remoteUrl;

import createStore from 'app/desktop/store';
import renderComponent from 'app/common/helpers/renderComponent';
import NotificationRoot from 'app/desktop/components/notifications/Notifications';
import InAppMessagesRoot from 'app/desktop/components/inAppMessages/inAppMessages';
import subscribers from 'app/common/subscribers';
import { dispatchEvent } from 'src/frontend/helper/event';

import { init, fetchData } from 'app/desktop/actions/app';
// import { parsed } from 'src/frontend/core/browser_events';

const store = createStore();

export default (hasSearch = false) => {
  require('preact/devtools');
  // subscribe state change
  subscribers(store);

  // // init app data
  store.dispatch(init(window.__LS_INITIAL_STATE__));
  // // lazy load data from storage
  store.dispatch(fetchData());

  // render root components

  renderComponent(store, InAppMessagesRoot, 'ls-in-app-messages');
  renderComponent(
    store,
    NotificationRoot,
    'ls-search-bar-wrapper',
    'ls-header-inbox-flyout-container'
  );

  if (hasSearch) {
    import('app/desktop/components/search/SearchBar').then(
      ({ default: SearchBarRoot }) => {
        renderComponent(
          store,
          SearchBarRoot,
          'ls-search-bar-wrapper',
          'ls-search-form'
        );
        dispatchEvent('loaded-preact-search');
      }
    );
  }
};

// parsed.then(initClient);
